<div class="lens bc-work-item-theme">
  <div class="lens-module-container" tabindex="1" (click)="setFocus(lensContainer)" #lensContainer>
  </div>
</div>
